<li class="logbook-events-item" *ngIf="event.type != 'requests.priority.updated'">
    <span class="date"><em><strong>{{event.date | date:'dd MMM yyyy'}}</strong><br>at {{event.date | date:'HH:mm'}}</em></span>
    <span class="ball"></span>
    <div class="lb-box" [ngClass]="{'event-group-selected': (event.group == activatedGroup)}">
        <project-details-logbook-event-header 
            [event]="event" 
            [activatedGroup]="activatedGroup"
            (open)="onOpen($event)" 
            (selectGroup)="onSelectGroup($event)"
        ></project-details-logbook-event-header>
        <div *ngIf="opened" class="event-content">
            <project-details-logbook-event-properties-main [event]="event"></project-details-logbook-event-properties-main>
        </div>
    </div>
</li>
